import 'iframe-resizer/js/iframeResizer.contentWindow';
import App from './components/App/App.svelte';

const urlParams = new URLSearchParams(window.location.search);

// only initialize app if id was defined
if (urlParams.has('id')) {
    const app = new App({
        target: document.body,
        props: {
            surveyId: urlParams.get('id'),
        },
    });
}

export default app;
